const common = {
  "site.name": "USFans Polska",
  "site.tagline": "Spreadsheet",
  "nav.home": "Strona główna",
  "nav.articles": "Artykuły",
  "nav.ranking": "Rankingi",
  "nav.poradniki": "Poradniki",
  "nav.kategorie": "Kategorie",
  "nav.category_placeholder": "Wybierz kategorię...",
  "cta.buy_now": "Kup teraz",
  "cta.usfans_spreadsheet": "USFans Spreadsheet",
  "cta.view_spreadsheet": "Sprawdź najnowszy USFans Spreadsheet",
  "cta.compare": "Porównaj arkusze",
  "cta.go_to_main": "Przejdź do kaspreadsheet.com",
  "footer.rights": "Wszelkie prawa zastrzeżone.",
  "footer.disclaimer": "Informacje mają charakter edukacyjny. Nie przechowujemy danych użytkowników.",
  "footer.newsletter_title": "Zapisz się do newslettera",
  "footer.newsletter_desc": "Otrzymuj najnowsze informacje o arkuszach USFans",
  "footer.newsletter_placeholder": "Twój adres e-mail",
  "footer.newsletter_button": "Zapisz się",
  "footer.categories": "Kategorie",
  "footer.articles": "Artykuły",
  "footer.info": "Informacje",
  "footer.privacy": "Polityka prywatności",
  "footer.terms": "Regulamin",
  "footer.contact": "Kontakt",
  "trust.daily": "Aktualizowane codziennie",
  "trust.safe": "Bezpieczne informacje",
  "trust.experts": "Przewodniki ekspertów",
  "trust.free": "Darmowe porównania",
};

export default common;